import { useFormContext, useWatch } from 'react-hook-form'

import { useDigitalProductStore } from '@/features/store/hook'
import { canRedeemFromStore } from '@/features/store/lib/storeHours'
import { Button } from '@/shared/ui/Button'
import { GameIcon } from '@/shared/ui/GameIcon'
import { useResourceContext } from '@/shared/ui/Resource'

import { isRedeemBlocked, itemPrice, redeemBlockMessage } from '../lib/redeemBlock'
import { isSoldOut } from '../lib/stock'

export const DigitalProductStoreBottomSheetFooter = ({ children }) => {
  const { reward_items, isClaim } = useResourceContext()
  const { formState } = useFormContext()
  const { isValid } = formState
  const quantity = useWatch({ name: 'quantity', defaultValue: 1 })
  const variation = useWatch({ name: 'reward_item_id', defaultValue: '' })
  const selectedVariation = reward_items.find(item => item.id === variation)
  /* O prazo de retirada saiu daqui em 2026-09-17, junto com a expiração
     automática: a reserva não vence mais sozinha, então "Retire até 18h00"
     prometeria uma perda que não acontece. O que continua valendo é o
     fechamento da lojinha para **reservar**, e disso quem fala é o botão. */
  const { storeStatus } = useDigitalProductStore()

  /* Fora da janela a api recusa com `reward_shop_closed`. O botão diz isso em
     vez de aceitar o toque e devolver um erro — o Participante que escolheu a
     variação e a quantidade não deve descobrir no envio que a loja fechou. */
  const isClosed = !canRedeemFromStore(storeStatus)

  // Critério é estoque, e não `redeemable`, que o serializer devolve nulo para
  // quem ainda não tem progresso no evento. A lista chega pelo mesmo poll de
  // 60s que alimenta a vitrine, então esgotar com o sheet aberto desabilita o
  // resgate sem o Participante tocar em nada.
  const isSelectedVariationSoldOut =
    !!selectedVariation && isSoldOut(selectedVariation)

  // A decisão é da API: o mesmo serviço avalia a listagem e o resgate, então o
  // botão nunca oferece o que a criação do pedido vai recusar.
  const redeemBlocked = isRedeemBlocked(selectedVariation)

  return (
    <div className="flex w-full flex-col gap-2">
      {redeemBlocked && (
        <p
          className="m-0 text-center text-xs font-semibold text-gray-600"
          role="status"
        >
          {redeemBlockMessage(selectedVariation?.redeem_blocked_reason)}
        </p>
      )}
      <div className="flex gap-4">
        {children}
        <Button
          variant="primary"
          type="submit"
          form="reward_request"
          disabled={!isValid || isClaim || isClosed || redeemBlocked || isSelectedVariationSoldOut}
          showTrailingIcon={false}
          className="flex-grow [&>span]:flex [&>span]:w-full [&>span]:items-center [&>span]:justify-between"
        >
          <>
            <span className="text-base font-bold">
              {isClosed ? 'Lojinha fechada' : isClaim ? 'Reservando...' : 'Reservar'}
            </span>
            {!isClosed && (quantity || quantity == 0) && selectedVariation && (
              <span className="flex items-center justify-center">
                <GameIcon name="coins" size={20} className="mr-2" />
                <span className="text-lg font-bold">
                  {quantity * itemPrice(selectedVariation)}
                </span>
              </span>
            )}
          </>
        </Button>
      </div>
    </div>
  )
}
